import React from "react";
import { useLocation } from "react-router-dom";
import Header from "../Header/Header";
import Footer from "../Footer/Footer";
import Images from "../../Assets/Images/Index";
function LearnMore() {
  const location = useLocation();
  const { card } = location.state || {};

  return (
    <div style={{backgroundColor:"white"}}>
      <Header />
      <div className="goal-main-cont container">
        <div className="d-flex justify-content-center">
          <h1>Fuel Your Ambition at Goal </h1>
        </div>

        {card ? (
          <div>
            <h1
              className="d-flex justify-content-center"
              style={{ color: "#f04b3d" }}
            >
              {card.name}
            </h1>
            <p className="d-flex justify-content-center learnmore">
              {card.description}
            </p>
            <div className="img-learn">
              <img
                src={card.image}
                alt={card.name}
                className="img-fluid"
                style={{
                  borderRadius: "15px",
                 
                }}
              />

              <div className="learn-board ">
                {[
                  { title: "Signup", image: Images.learn1 },
                  { title: "Template", image: Images.learn2 },
                  { title: "QR Scan", image: Images.learn3 },
                  { title: "Explore", image: Images.learn4 },
                ].map((item, index) => (
                  <div key={index} className="d-flex align-items-center mb-5">
                    <img src={item.image} alt={item.title} className="me-4" />
                    <div>
                      <h2 style={{ fontWeight: "bold" }}>{item.title}</h2>
                      <p>
                        Provide some basic information such as your addressing
                        and montage information
                      </p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        ) : (
          <p>No data available.</p>
        )}
      </div>
      <Footer />
    </div>
  );
}
  
export default LearnMore;
